import React from 'react';
// import { Row, Col, Image, Space, Typography, Collapse, Grid } from 'antd';
import { Row, Col, Image, Space, Typography, Grid } from 'antd';
import Clay from '../../assets/img/clay-banks-e6pK_snssSY-unsplash.png';

const { useBreakpoint } = Grid;
const { Text } = Typography;
// const { Panel } = Collapse;

function Theme() {
  const { xs } = useBreakpoint()
  return (
    <React.Fragment>
      {
        xs ?
          <Row className='content-body' justify="space-around" align="middle" gutter={[0,32]} style={{ backgroundColor: '#fff' }}>
            <Col span={24}>
              <Image
                width={'100%'}
                src={Clay}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={24}>
              <Space direction="vertical" size={16}>
                <Space direction="vertical">
                  {/* <Text style={{ fontSize: 20, fontWeight: 'bold' }}>Theme and Topic</Text> */}
                  <Text style={{ fontSize: 20, fontWeight: 'bold' }}>Topic</Text>
                </Space>
                {/* <Collapse bordered={false} defaultActiveKey={['2']} gutter={128} style={{ backgroundColor: '#fff' }}> */}
                  {/* <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Theme</Text>} key="1">
                    <Text style={{ fontSize: 16 }}>Connecting People in Health and Social Sciences</Text>
                  </Panel> */}
                  {/* <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Topic</Text>} key="2"> */}
                    <ol style={{ marginLeft: -24 }}>
                      <li><Text style={{ fontSize: 16 }}>The Interconnection Between Occupational Health and Public Health: An Integrated Approach</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Intersections of Climate Change, Air Pollution, Public Health, and Social Life</Text></li>
                      <li><Text style={{ fontSize: 16 }}>The Future of Work: AI, Precarious Employment, and Public Health</Text></li>
                      <li><Text style={{ fontSize: 16 }}>AI-Driven Solutions for Excellent Service in Health, Social Innovation, and Creative Economy Sector</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Climate Change and Food Security: Challenges and Solutions</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Mental health Issues Caused by AI Utilization: AI Related Mental Health Concerns</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Technology Development for Public Safety</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Resilient Tourism: Strategies for Pandemic Preparedness and Public Health Protection</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Occupational Health as Part of The Environmental Responsibility of Industries</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Vulnerable Populations: The Impact of Air Pollution on Pregnant Women and Fetal Development</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Interdisciplinary Approaches to Reducing Air Pollution Exposure Among Children and Pregnant Women</Text></li>
                      <li><Text style={{ fontSize: 16 }}>The Role of Occupational Health in Managing Non-Communicable Diseases (NCDs)</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Integrating Nursing and Midwifery Care Into Public Health System</Text></li>
                      <li><Text style={{ fontSize: 16 }}>AI Innovation in Long Term Patient Care Management</Text></li>
                      <li><Text style={{ fontSize: 16 }}>AI Applications to Support Clinical Laboratory Accuracy</Text></li>
                    </ol>
                  {/* </Panel> */}
                {/* </Collapse> */}
              </Space>
            </Col>
          </Row>
        :
          <Row className='content-body' justify="space-around" align="middle" gutter={64} style={{ backgroundColor: '#fff' }}>
            <Col span={12}>
              <Image
                width={'100%'}
                src={Clay}
                preview={false}
                style={{ objectFit: 'cover' }}
              />
            </Col>
            <Col span={12}>
              <Space direction="vertical" size={32}>
                <Space direction="vertical" size={-8}>
                  {/* <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Theme and Topic</Text> */}
                  <Text style={{ fontSize: 28, fontWeight: 'bold' }}>Topic</Text>
                </Space>
                {/* <Collapse bordered={false} defaultActiveKey={['2']} gutter={128} style={{ backgroundColor: '#fff' }}> */}
                  {/* <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Theme</Text>} key="1">
                    <Text style={{ fontSize: 16 }}>Connecting People in Health and Social Sciences</Text>
                  </Panel> */}
                  {/* <Panel header={<Text style={{ fontSize: 18, fontWeight: 'bold' }}>Topic</Text>} key="2"> */}
                    <ol style={{ marginLeft: -24 }}>
                      <li><Text style={{ fontSize: 16 }}>The Interconnection Between Occupational Health and Public Health: An Integrated Approach</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Intersections of Climate Change, Air Pollution, Public Health, and Social Life</Text></li>
                      <li><Text style={{ fontSize: 16 }}>The Future of Work: AI, Precarious Employment, and Public Health</Text></li>
                      <li><Text style={{ fontSize: 16 }}>AI-Driven Solutions for Excellent Service in Health, Social Innovation, and Creative Economy Sector</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Climate Change and Food Security: Challenges and Solutions</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Mental health Issues Caused by AI Utilization: AI Related Mental Health Concerns</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Technology Development for Public Safety</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Resilient Tourism: Strategies for Pandemic Preparedness and Public Health Protection</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Occupational Health as Part of The Environmental Responsibility of Industries</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Vulnerable Populations: The Impact of Air Pollution on Pregnant Women and Fetal Development</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Interdisciplinary Approaches to Reducing Air Pollution Exposure Among Children and Pregnant Women</Text></li>
                      <li><Text style={{ fontSize: 16 }}>The Role of Occupational Health in Managing Non-Communicable Diseases (NCDs)</Text></li>
                      <li><Text style={{ fontSize: 16 }}>Integrating Nursing and Midwifery Care Into Public Health System</Text></li>
                      <li><Text style={{ fontSize: 16 }}>AI Innovation in Long Term Patient Care Management</Text></li>
                      <li><Text style={{ fontSize: 16 }}>AI Applications to Support Clinical Laboratory Accuracy</Text></li>
                    </ol>
                  {/* </Panel> */}
                {/* </Collapse> */}
              </Space>
            </Col>
          </Row>
      }
    </React.Fragment>
  )
}

export default Theme